<div *ngIf="!isConsestUsedBefore">
	<div class="consent-box flex-container direction-column" *ngIf="!IsShowSettings">
		<div class="consent-title green-font">
			<h2 translate>Consent.Title</h2>
		</div>

		<div class="consent-desc flex-container direction-column">
			<span translate>Consent.Desc0</span>
			<span><span translate>Consent.Desc1</span><a routerLink="/privacy" translate>Consent.Privacy</a></span>
		</div>

		<div class="consent-buttons flex-container direction-row flex-between">
			<a (click)="showSettings()" class="mark-button button-cut" translate>Consent.Customize</a>
			<a (click)="saveDefault()" class="mark-button button-cut" translate>Consent.Reject</a>
			<a (click)="saveAll()" class="mark-button button-cut" translate>Consent.Accept</a>
		</div>
	</div>
	<div class="consent-box flex-container direction-column" *ngIf="IsShowSettings">
		<div class="consent-title green-font">
			<h2 translate>Consent.SettingsTitile</h2>
		</div>
		<div class="consent-settings flex-container direction-column">
			<div class="settings-block" *ngFor="let item of rules; let i = index;">
				<div class="settings-title flex-container direction-row flex-between align-center">
					<span class="feature-title">{{item.ruleTitle|translate}}</span>
					<mat-slide-toggle *ngIf="!item.noState" [(ngModel)]="item.isSelected" (ngModelChange)="setState(item)"></mat-slide-toggle>
				</div>
				<div class="settings-title" [ngClass]="{'truncate':!item.showMore}">{{item.ruleDescription|translate}}</div>
				<a href="#" *ngIf="item.hasMore" class="show-more" (click)="item.showMore=!item.showMore">
					<span *ngIf="!item.showMore" translate> Consent.Show</span>
					<span *ngIf="item.showMore" translate> Consent.Hide</span>
				</a>
			</div>
		</div>
		<div class="consent-buttons flex-container direction-row flex-between">
			<a (click)="rejectSettings()" class="mark-button button-cut" translate>Consent.Reject</a>
			<a (click)="saveAll()" class="mark-button button-cut" translate>Consent.Accept</a>
		</div>
	</div>

</div>
